const noop = function () {};
window.pageLoadFinish = noop;
window.nativeWebWillAppear = noop;
window.webviewAppear = noop;
window.webviewDisappear = noop;
window.onNetStateChange = noop;
window.nativeResponseAudioStatus = noop;
window.nativeResponseAudioProgress = noop;
window.getNativeFetusActionDataCallBack = noop;
window.downloadImageToNativeAlbumCallBack = noop;
window.notifyH5MoveMentPlayStatusCallBack = noop;
window.backOrderInfo = noop;
window.thridShareSuccess = noop;
window.getLoadTime = noop;
window.selectionAddressCall = noop;
window.refreshTDSquare = noop;
window.installSharePlatform = noop;
window.share = window.share || {};
window.share.success = noop;
window.nativeGetNetStateFinishCall = noop;
if (window.android) {
  window.android.nativeGetNetState = noop;
  window.android.nativeArousePayCallback = noop;
  window.android.getLoadTime = noop;
  window.android.adAction = noop;
}
